import { hashCode as gerarHashCode, getQueryStringParam } from 'lg-vue-components/utils';

const utils = {
  atualizeControleMenu(state, { codigo, uid, descricao }) {
    state.menuAtivo = codigo || '';
    state.menuUid = uid || '';

    sessionStorage.setItem('MENU_DESCRICAO', descricao || '');
    sessionStorage.setItem('MENU_ATIVO', state.menuAtivo);
    sessionStorage.setItem('MENU_UID', state.menuUid);
  },
  mapeieObjetoMenu(menu) {
    return menu.map((itemMenu) => {
      if (itemMenu.itens && itemMenu.itens.length) {
        return utils.mapeieObjetoMenu(itemMenu.itens);
      }

      return {
        codigo: itemMenu.codigo,
        url: itemMenu.url,
        acao: itemMenu.acao,
        uid: itemMenu.uid,
        ehMenuPrincipal: true,
      };
    }).flat();
  },
  mapeieMenuSeNaoExiste(state, menus) {
    if (menus && Array.isArray(menus)) {
      menus.forEach((menu) => {
        if (!menu.uid) {
          // eslint-disable-next-line
          menu.uid = utils.getUID(menu);
        }

        // eslint-disable-next-line
        if (state.menuMapeado.filter((x) => x.uid == menu.uid).length === 0) {
          state.menuMapeado.push(menu);
        }
      });
    }
  },
  buscarPaisPorUID(menu, uid) {
    const visitados = [];
    const menuFoiEncontrado = utils.burcarMenuRecursivo(menu, uid, visitados, 'uid');

    return menuFoiEncontrado ? visitados : [];
  },
  buscarPaisDoMenu(menu, codigo) {
    const visitados = [];
    const menuFoiEncontrado = utils.burcarMenuRecursivo(menu, codigo, visitados);

    return menuFoiEncontrado ? visitados : [];
  },
  burcarMenuRecursivo(menu, codigo, visitados) {
    return menu.some((itemMenu, index) => {
      if (itemMenu.codigo === codigo) return true;

      if (!visitados.includes(itemMenu.codigo)) {
        if (itemMenu.itens && itemMenu.itens.length) {
          visitados.push(itemMenu.codigo);
          return utils.burcarMenuRecursivo(itemMenu.itens, codigo, visitados);
        }
      }

      if (index === menu.length - 1) visitados.pop();

      return false;
    });
  },
  tenteRecuperarParametrosDaQuery(state) {
    if (!state.menuAtivo) {
      const idQuery = getQueryStringParam('id');
      const uidQuery = getQueryStringParam('uid');

      state.menuAtivo = idQuery || '';
      state.menuUid = uidQuery || '';
    }
  },
  mapeiaUID(listaFinal, menus) {
    if (menus && menus.length) {
      menus.forEach((itemMenu) => {
        if (itemMenu.itens && itemMenu.itens.length) {
          const novosItens = [];

          utils.mapeiaUID(novosItens, itemMenu.itens);

          itemMenu.itens.splice(0);
          // eslint-disable-next-line
          itemMenu.itens = [...novosItens];
          listaFinal.push(itemMenu);
        } else {
          listaFinal.push({
            ...itemMenu,
            uid: utils.getUID(itemMenu),
          });
        }
      });
    }
  },
  getUID(menu) {
    if (!menu) {
      return '';
    }

    return gerarHashCode(`${menu.codigo}_${menu.descricao}`);
  },
};

export default utils;
